import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetQuestionListAppendSucceed, EGetQuestionListActionType } from './types';
import { IQuestionList } from '../../../types/questionList';

export const getQuestionListAppendSucceed: (data: IQuestionList) => TGetQuestionListAppendSucceed = actionGenerator<
  EGetQuestionListActionType.AppendSucceed,
  IQuestionList
>(EGetQuestionListActionType.AppendSucceed);
